import { URSSAF } from '@/utils/logos'

export const docCotisationFrontalierSuisse = {
	url: 'https://www.urssaf.fr/accueil/particulier/travailleur-frontalier-suisse/declarer-payer-cotisations.html#ancre-le-calcul-de-votre-cotisation',
	title: 'Déclarer et payer votre cotisation maladie',
	description:
		'Le détail du calcul de la cotisation et les modalités de déclaration et de paiement.',
	logo: URSSAF,
}
